<!-- MOSTRA ELS DOCUMENTS DIGITALS DE LES ROUTEPARTS DE LA RUTA INDICADA PER UUIDQR -->
<div class="logo">
    <shared-external-logo *ngIf="value != null" [tenantId]="value.tenantId"></shared-external-logo>
</div>
<ng-container *ngIf="value == null || value.routePartCMRs == null || value.routePartCMRs.length == 0">
    <div class="block-esquerra">
        <div class="header"></div>
        <div class="nouuid">
            No valid uuid
        </div>
    </div>
</ng-container>
<div *ngIf="value != null && value.routePartCMRs != null && value.routePartCMRs.length > 0" class="container qrcmr">
    <div class="block-esquerra">

        <div class="bar">
            <div class="baroptions">
                <options class="nomenu" [optionstrip]="options" (clickOption)="onClickOption($event)"></options>
            </div>
            <div class="baractions">
                <shared-route-ecmr-actions [onlyIcons]="true" [routeUUDQR]="uuid"></shared-route-ecmr-actions>
            </div>
        </div>

        <shared-route-part-cmr-digitaldocument-component class="no-actions-rpc" *ngIf="optionSelected != 'GENERAL' && getRoutePartCMRId() > 0" [external]="true" [routePartCMRId]="getRoutePartCMRId()" [avoidOptionFirma]="true">
        </shared-route-part-cmr-digitaldocument-component>
        <div *ngIf="optionSelected == 'GENERAL'">
            <shared-route-part-cmr-digitaldocument-component class="no-actions-rpc" *ngFor="let rpc of value.routePartCMRs" [external]="true" [routePartCMRId]="rpc.routePartCMRId" [avoidOptionFirma]="true">
            </shared-route-part-cmr-digitaldocument-component>        
        </div>
        <shared-documentaryreview-item-documents-component class="block-data"
                [parentObject]="parentObject" (dataRefresh)="onDocumentValueChanged()"
                [resourceTitle]="'DOCUMENTARYREVIEW.IMPORT.TITLE'"></shared-documentaryreview-item-documents-component>
    
        <div class="dummy"></div>
    </div>
</div>